var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-112.7 -112.7 715.40 715.40",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    stroke: "#ffffff",
    strokeWidth: 0.0049,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -112.7,
    y: -112.7,
    width: 715.4,
    height: 715.4,
    rx: 357.7,
    fill: "#ffc852",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#ffffffCCCCCC",
    strokeWidth: 0.9800000000000001
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.241,71.759C371.967,25.484,310.442,0,245,0S118.033,25.484,71.759,71.759C25.485,118.034,0,179.559,0,245 s25.484,126.967,71.759,173.241C118.034,464.515,179.558,490,245,490s126.967-25.484,173.241-71.759 C464.515,371.966,490,310.441,490,245S464.516,118.033,418.241,71.759z M448.29,174.999l-29.065,7.788 c-7.599-21.218-18.97-40.653-33.302-57.499l21.268-21.268C425.122,124.621,439.195,148.659,448.29,174.999z M315,41.709 c26.34,9.095,50.378,23.167,70.979,41.098l-21.268,21.268c-16.846-14.332-36.281-25.702-57.499-33.301L315,41.709z M245,30 c14.027,0,27.739,1.366,41.023,3.943l-7.785,29.054C267.452,61.032,256.345,60,245,60c-11.345,0-22.452,1.032-33.239,2.997 l-7.785-29.054C217.261,31.366,230.973,30,245,30z M175,41.709l7.788,29.065c-21.219,7.6-40.653,18.97-57.499,33.302 l-21.268-21.269C124.622,64.877,148.66,50.805,175,41.709z M82.807,104.02l21.268,21.269 c-14.331,16.846-25.701,36.28-33.301,57.498l-29.065-7.788C50.804,148.66,64.877,124.622,82.807,104.02z M30,245 c0-14.027,1.366-27.738,3.943-41.023l29.054,7.785C61.032,222.548,60,233.655,60,245c0,11.267,1.016,22.379,2.983,33.242 l-29.039,7.781C31.366,272.738,30,259.027,30,245z M41.71,315.001l29.004-7.771c7.453,20.863,18.69,40.306,33.349,57.496 L82.808,385.98C64.878,365.379,50.805,341.341,41.71,315.001z M245,460c-53.889,0-103.207-19.933-140.979-52.807l121.59-121.59 C231.486,288.419,238.061,290,245,290c24.813,0,45-20.187,45-45s-20.187-45-45-45s-45,20.187-45,45 c0,6.939,1.581,13.515,4.398,19.39l-79.045,79.045C102.459,315.731,90,281.303,90,245c0-85.467,69.533-155,155-155 s155,69.533,155,155c0,41.329-16.143,80.233-45.455,109.545l-10.607,10.606l42.041,42.042C348.207,440.067,298.889,460,245,460z M230,245c0-8.271,6.729-15,15-15s15,6.729,15,15s-6.729,15-15,15S230,253.271,230,245z M407.192,385.98l-21.247-21.248 c14.66-17.19,25.881-36.642,33.333-57.505l29.012,7.774C439.195,341.341,425.122,365.379,407.192,385.98z M427.024,278.244 C428.991,267.381,430,256.267,430,245c0-11.345-1.032-22.452-2.997-33.238l29.054-7.785C458.634,217.262,460,230.973,460,245 s-1.366,27.738-3.943,41.023L427.024,278.244z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 394,
    width: 90,
    height: 30
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdle);
export default __webpack_public_path__ + "static/media/idle.421645a08bcc996fc399cd19dc720e6c.svg";
export { ForwardRef as ReactComponent };